import DOMPurify from 'dompurify';

// Add target="_blank" and rel="noopener noreferrer" to all <a> tags after sanitization
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export const HtmlContent = ({ html, className, as: Tag = 'span' }) => {
  if (!html) return null;

  // Content is sanitized by DOMPurify before being rendered
  const sanitized = DOMPurify.sanitize(html, {
    ADD_ATTR: ['target', 'rel'],
  });
  const classes = className ? `react-rich-text ${className}` : 'react-rich-text';
  return (
    <Tag className={classes} dangerouslySetInnerHTML={{ __html: sanitized }} />
  );
};
